function buildMenu(allowed) {
  if (allowed == null || allowed.includes('CRM')) {
    return [{
      title: 'CRM',
      icon: 'mdi-phone',
      items: [{
          icon: 'mdi-information-outline',
          title: "Release Notes",
          path: '/CrmReleaseNotes'
        },
        {
          icon: 'mdi-rocket-launch',
          title: 'Campaigns',
          path: '/CrmCampaign'
        },
        {
          icon: 'mdi-link',
          title: 'Campaign Links',
          path: '/CrmLink'
        },
        {
          icon: 'mdi-toy-brick-plus',
          title: 'Templates',
          path: '/CrmTemplate'
        },
        {
          icon: 'mdi-creation',
          title: 'Prospects',
          path: '/CrmProspect'
        },
        {
          icon: 'mdi-account-cancel',
          title: 'Unsubscribed',
          path: '/CrmUnsub'
        },
        {
          icon: 'mdi-clipboard-flow-outline',
          title: 'Workflows',
          path: '/CrmWorkflow'
        },
        {
          icon: 'mdi-rocket-launch',
          title: 'Campaign Create',
          path: '/CrmCampaignCreate'
        },
        {
          icon: 'mdi-filter',
          title: 'Sales Pipeline',
          path: '/CrmSalesPipeline'
        },
        {
          icon: 'mdi-handshake',
          title: 'Partners',
          path: '/CrmPartners'
        },
        {
          icon: 'mdi-download-multiple',
          title: 'Download Requests',
          path: '/CrmDownloadRequests'
        },
        {
          icon: 'mdi-email-receive',
          title: 'Incoming Messages',
          path: '/CrmMessages'
        },
      ]
    }]
  } else return []
}

export default buildMenu